import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Modal from "react-modal";
import moment from "moment";
import SubscriptionTable from "./SubscriptionTable";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import { formattedAmount } from "../../components/common-data/Converts";
import { formatDate } from "../../utils/utilityfunc";
import OneDayMembershipSubscriptions from "./OneDayMembershipSubscriptions";
import TableSkeleton from "../../components/common-components/TableSkeleton";
import CommonTable from "../../components/common-components/common-tables/CommonTable";
import SelectExportables from "../../components/common-components/SelectExportables";
import { fetchExportApiData } from "../../redux/reducers/commonApiSlice";
import { selectToken } from "../../components/auth/auth.selector";
import {
  CalendarIcon,
  CallIcon,
  ClockIconV3,
  DownloadIcon,
  EmailIcon,
  LocationIcon1,
  PersonIcon,
} from "../../images/icons/icons";
import { subscriptions } from "../../data/ApiEndpoints";
import { subscriptionExportableFields } from "./SubscriptionExportableData";

const SubsTavViewTable = ({
  decryptedText,
  allSubsTbData,
  setAllSubsTbData,
  callFunction,
  filters,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
}) => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const { loading } = useSelector((state) => state.api);
  const { exportData, exportLoading } = useSelector((state) => state.common);
  const isAdmin = decryptedText?.account_type === "admin";

  const [imageModal, setImageModal] = useState(false);
  const [viewImage, setViewImage] = useState("");
  const [csvData, setCsvData] = useState("");
  const [exportModal, setExportModal] = useState(false);
  const [currentTabFilters, setCurrentTabFilters] = useState(filters);

  const handleTabChange = () => {
    setIsPage(0);
  };

  const handleExportSubscriptions = (exportFilters) => {
    if (exportFilters.is_export) {
      dispatch(
        fetchExportApiData({
          method: "GET",
          endpoint: subscriptions,
          payload: {
            filters: exportFilters,
          },
          token: token,
        })
      );
    }
  };

  useEffect(() => {
    if (exportData) {
      setCsvData(exportData);
    } else {
      setCsvData("");
    }
  }, [exportData]);

  // const subsTbColumn1 = [
  //   {
  //     dataField: "details_user",
  //     text: "member Detail",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="emeberDetailsRowContainer">
  //           <img
  //             src={row?.profile || BodyBuilder}
  //             alt={row?.user_name || "NA"}
  //             className="image"
  //             onClick={() => {
  //               setViewImage(row?.profile || BodyBuilder);
  //               setImageModal(true);
  //             }}
  //           />

  //           <div className="flexColumn">
  //             <span className="tb-data" style={{ textAlign: "start" }}>
  //               {row?.user_name || "NA"}
  //               <br />
  //               <small className="underline lowercase">
  //                 {row?.user_mobile || ""}
  //                 <br />
  //                 {row?.user_email || ""}
  //               </small>
  //               {row?.experience_level && (
  //                 <>
  //                   <br />
  //                   <small className="gray underline">
  //                     {row?.experience_level}
  //                   </small>
  //                 </>
  //               )}
  //             </span>
  //           </div>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "gym_name",
  //     text: "Gym Name",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data minWidth150" style={{ textAlign: "start" }}>
  //           <small>{row?.gym_name || "NA"}</small>
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "source_name",
  //     text: "Source Name",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data minWidth90">
  //           {row?.source_name?.replace(/_/g, " ") || "-"}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "plan_name",
  //     text: "Plan Name",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data minWidth150">
  //           <small className="underline gray">
  //             {row?.one_day_membership
  //               ? "One Day"
  //               : row?.type === "addon_pt"
  //               ? "PT"
  //               : row?.type?.replace(/_/g, " ") || "NA"}
  //           </small>
  //           <br />
  //           <small>
  //             {row?.type === "regular"
  //               ? row?.plan_name
  //               : row?.addon_name || "NA"}
  //           </small>
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "price",
  //     text: "Price",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data">
  //           ₹{row?.price ? formattedAmount(row.price) : 0}
  //           <br />
  //           <small
  //             className="gray underline"
  //             style={{ textTransform: "initial" }}
  //           >
  //             {row?.trx_id === "cash"
  //               ? "Cash"
  //               : row?.trx_id === "import_member"
  //               ? row.trx_id?.replace(/_/g, " ")
  //               : `Online/${row?.trx_id}` || "NA"}
  //           </small>
  //           {row?.payment_location && (
  //             <>
  //               <br />
  //               <small className="underline">
  //                 (
  //                 {row.payment_location === "gym"
  //                   ? "Inside Gym"
  //                   : "Outside Gym"}
  //                 )
  //               </small>
  //             </>
  //           )}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "subscription_added",
  //     text: "Subs Start/Expire Date",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data minWidth100">
  //           <small className="gray underline">
  //             {row?.subscription_added
  //               ? formatDate(row.subscription_added)
  //               : "-"}
  //           </small>
  //           <br />
  //           {row?.start_date
  //             ? moment(row.start_date).tz("Asia/Kolkata").format("DD-MM-YYYY")
  //             : "-"}
  //           <br />/
  //           {row?.expire_date
  //             ? moment(row.expire_date).tz("Asia/Kolkata").format("DD-MM-YYYY")
  //             : "-"}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "subscription_status",
  //     text: "Subs Status",
  //     formatter: (_, row) => {
  //       return (
  //         <span
  //           className="tb-data withPadding borderRdius8 minWidth150"
  //           style={{
  //             background:
  //               row?.subscription_status === "active" ? "#379C00" : "#C90808",
  //             color: "#fff",
  //           }}
  //         >
  //           <small>{row?.subscription_status || "NA"}</small>
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "checkout_source",
  //     text: "Checkout Source",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data">
  //           {row?.checkout_source?.replace(/_/g, " ") || "-"}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "gender",
  //     text: "Gender",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data">
  //           {row?.gender === "male" ? "♂" : row?.gender === "female" ? "♀" : ""}{" "}
  //           <br />
  //           {row?.gender || "-"}
  //         </span>
  //       );
  //     },
  //   },
  // ];

  const tbColumns = [
    {
      dataField: "user_name",
      text: "member info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>{" "}
              <span className="tb-data">{row?.user_name || "NA"}</span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CallIcon />
              </span>{" "}
              <span className="tb-data">{row?.user_mobile || "NA"}</span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <EmailIcon />
              </span>{" "}
              <span className="tb-data lowercase">
                {row?.user_email || "NA"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 25;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              {row?.one_day_membership
                ? "One Day"
                : row?.type === "addon_pt"
                ? "PT"
                : row?.type?.replace(/_/g, " ") || "NA"}
            </span>

            <span className="tb-data">
              {" "}
              {row?.type === "regular"
                ? row?.plan_name
                : row?.addon_name || "NA"}{" "}
              @₹{row?.price ? formattedAmount(row.price) : 0}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "subscription_status",
      text: "Subs Status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-badge ${
              row?.subscription_status === "active"
                ? "tb-badge-success"
                : "tb-badge-stuck"
            }`}
          >
            {row?.subscription_status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "trx_id",
      text: "transaction ID",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              {row?.is_imported === 1
                ? "Import Member"
                : row?.trx_id === "cash"
                ? "Cash"
                : `Online/${row?.trx_id}` || "NA"}
            </span>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <LocationIcon1 />
              </span>{" "}
              <span className="tb-data">
                {row.payment_location === "gym" ? "Inside Gym" : "Outside Gym"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "subscription_added",
      text: "Add Date",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <ClockIconV3 />
            </span>{" "}
            <span className="tb-data">
              {row?.subscription_added
                ? formatDate(row.subscription_added)
                : "-"}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "start_date",
      text: "duration",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalendarIcon />
              </span>{" "}
              <span className="tb-data">
                {row?.start_date
                  ? moment(row.start_date)
                      .tz("Asia/Kolkata")
                      .format("DD-MM-YYYY")
                  : "-"}
              </span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalendarIcon />
              </span>{" "}
              <span className="tb-data">
                {row?.expire_date
                  ? moment(row.expire_date)
                      .tz("Asia/Kolkata")
                      .format("DD-MM-YYYY")
                  : "-"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "source_name",
      text: "Source Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.source_name?.replace(/_/g, " ") || "-"}
          </span>
        );
      },
    },
    {
      dataField: "checkout_source",
      text: "Checkout Source",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {" "}
            {row?.checkout_source?.replace(/_/g, " ") || "-"}
          </span>
        );
      },
    },
    {
      dataField: "checkout_source",
      text: "Gender",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.gender === "male" ? "♂" : row?.gender === "female" ? "♀" : ""}{" "}
            {row?.gender || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "experience_level",
      text: "experience",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.experience_level || "NA"}</span>;
      },
    },
    ...(isAdmin
      ? [
          {
            dataField: "actions",
            text: "Actions",
            formatter: (_, row) => {
              return (
                <div className="pp-employee-payroll-actions">
                  <button
                    key="available-trainers"
                    type="button"
                    className={`pp-employee-payroll-action-button pp-outlined-border ${
                      !row?.invoice_link ? "disabled" : ""
                    }`}
                    onClick={() => {
                      if (row?.invoice_link) {
                        window.open(row.invoice_link, "_blank");
                      } else return;
                    }}
                    disabled={!row?.invoice_link}
                  >
                    <DownloadIcon color="#000" />
                    invoice
                  </button>
                </div>
              );
            },
          },
        ]
      : []),
  ];

  return (
    <>
      <Modal
        isOpen={imageModal}
        onRequestClose={() => {
          setImageModal(false);
          setViewImage("");
        }}
        contentLabel="View Image Modal"
        ariaHideApp={false}
      >
        <div
          className="createNewCTOModalContainer discussionModalBriefContainer"
          style={{
            width: "auto",
            height: "auto",
          }}
        >
          <ModalHeadAndClose
            title=" "
            onClose={() => {
              setImageModal(false);
              setViewImage("");
            }}
          />
          <div className="discussionModalMessage mt30">
            <img
              src={viewImage}
              alt="profile"
              style={{
                width: "400px",
                height: "400px",
              }}
            />
          </div>
        </div>
      </Modal>

      <Tabs onSelect={handleTabChange}>
        <TabList>
          <Tab>All Subscriptions</Tab>
          <Tab>New Subscriptions</Tab>
          <Tab>Renewals</Tab>
          <Tab>ODM</Tab>
        </TabList>

        <TabPanel>
          <div className="flexEnd mt15">
            <button
              className="btn-k red-bg-k"
              onClick={() => {
                setCurrentTabFilters(filters);
                setExportModal(true);
              }}
            >
              Choose To Export
            </button>
          </div>

          {loading ? (
            <TableSkeleton columns={9} rows={5} />
          ) : (
            <SubscriptionTable
              allSubsTbData={allSubsTbData}
              setAllSubsTbData={setAllSubsTbData}
              decryptedText={decryptedText}
              callSubscription={callFunction}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          )}
        </TabPanel>
        <TabPanel>
          <div className="flexEnd mt15">
            <button
              className="btn-k red-bg-k"
              onClick={() => {
                setCurrentTabFilters({ ...filters, subscription_type: "new" });
                setExportModal(true);
              }}
            >
              Choose To Export
            </button>
          </div>

          <div className="common-table-container tb-bordered mt15">
            <CommonTable
              tableData={
                allSubsTbData.newSusbcriptions?.length > 0
                  ? allSubsTbData.newSusbcriptions
                  : []
              }
              tableColumns={tbColumns}
              tablePagination={allSubsTbData.totalNewPagination}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              isLoading={loading}
            />
          </div>

          {/* <div
            className="subscriptionTbContainer"
            style={{ marginTop: "20px" }}
          >
            {loading ? (
              <TableSkeleton columns={9} rows={5} />
            ) : (
              <PaymentLinkTable
                tableData={
                  allSubsTbData.newSusbcriptions?.length > 0
                    ? allSubsTbData.newSusbcriptions
                    : []
                }
                tableColumns={subsTbColumn1}
                tablePagination={allSubsTbData.totalNewPagination}
                isPage={isPage}
                setIsPage={setIsPage}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            )}
          </div> */}
        </TabPanel>
        <TabPanel>
          <div className="flexEnd mt15">
            <button
              className="btn-k red-bg-k"
              onClick={() => {
                setCurrentTabFilters({
                  ...filters,
                  subscription_type: "renewal",
                });
                setExportModal(true);
              }}
            >
              Choose To Export
            </button>
          </div>

          <div className="common-table-container tb-bordered mt15">
            <CommonTable
              tableData={
                allSubsTbData.renewalSubscription?.length > 0
                  ? allSubsTbData.renewalSubscription
                  : []
              }
              tableColumns={tbColumns}
              tablePagination={allSubsTbData.totalRenewalPagination}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              isLoading={loading}
            />
          </div>

          {/* <div
            className="subscriptionTbContainer"
            style={{ marginTop: "20px" }}
          >
            {loading ? (
              <TableSkeleton columns={9} rows={5} />
            ) : (
              <PaymentLinkTable
                tableData={
                  allSubsTbData.renewalSubscription?.length > 0
                    ? allSubsTbData.renewalSubscription
                    : []
                }
                tableColumns={subsTbColumn1}
                tablePagination={allSubsTbData.totalRenewalPagination}
                isPage={isPage}
                setIsPage={setIsPage}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            )}
          </div> */}
        </TabPanel>
        <TabPanel>
          <div className="flexEnd mt15">
            <button
              className="btn-k red-bg-k"
              onClick={() => {
                setCurrentTabFilters({ ...filters, one_day_membership: 1 });
                setExportModal(true);
              }}
            >
              Choose To Export
            </button>
          </div>

          <OneDayMembershipSubscriptions
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            setViewImage={setViewImage}
            setImageModal={setImageModal}
          />
        </TabPanel>
      </Tabs>

      {/* Export Modal */}
      <Modal
        isOpen={exportModal}
        onRequestClose={() => setExportModal(false)}
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <ModalHeadAndClose
            title={"Select Fields To Export"}
            onClose={() => setExportModal(false)}
          />
          <SelectExportables
            name="subscriptions"
            exportableData={subscriptionExportableFields}
            filters={currentTabFilters}
            callFunction={handleExportSubscriptions}
            isLoadingCSV={exportLoading}
            csvData={csvData}
            setCsvData={setCsvData}
          />
        </div>
      </Modal>
    </>
  );
};

export default SubsTavViewTable;
